'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ELEMENT_TOP_RIGHT_READING_MODIFIER = exports.COLUMN_OVERLAP_THRESHOLD = exports.MIN_CHANGE_IN_SCREE_PLOT_SLOPE = exports.MAX_DIST_BETWEEN_BOTTOM_AND_TOP = exports.AUTO_COLUMN_DISTANCE = exports.AUTO_CLUSTER_DISTANCE = exports.SAME_COLOR_ADJUSTMENT = exports.SAME_TYPE_ADJUSTMENTS = undefined;

var _SAME_TYPE_ADJUSTMENT;

var _boardConstants = require('../boards/boardConstants');

var _linkConstants = require('../links/linkConstants');

var _imageConstants = require('../images/imageConstants');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Constants


// PARAMETERS
// Distance adjustments based on categorical data
var SAME_TYPE_ADJUSTMENTS = exports.SAME_TYPE_ADJUSTMENTS = (_SAME_TYPE_ADJUSTMENT = {}, _defineProperty(_SAME_TYPE_ADJUSTMENT, _boardConstants.BOARD_TYPE, 0.8), _defineProperty(_SAME_TYPE_ADJUSTMENT, _linkConstants.LINK_TYPE, 0.9), _defineProperty(_SAME_TYPE_ADJUSTMENT, _imageConstants.IMAGE_TYPE, 0.9), _SAME_TYPE_ADJUSTMENT);
var SAME_COLOR_ADJUSTMENT = exports.SAME_COLOR_ADJUSTMENT = 0.9;

// Distances below which we automatically create clusters (and ignore the scree plot slope)
// Disable for clusters
var AUTO_CLUSTER_DISTANCE = exports.AUTO_CLUSTER_DISTANCE = -1;
var AUTO_COLUMN_DISTANCE = exports.AUTO_COLUMN_DISTANCE = 2;

// This distance is used when elements can't be in the same column (because they don't overlap)
// possible change: instead of 1000 for max distance, this could be set to the current max (to avoid incorrect elbows)
var MAX_DIST_BETWEEN_BOTTOM_AND_TOP = exports.MAX_DIST_BETWEEN_BOTTOM_AND_TOP = 1000;

// This prevents clusters from being created if the line is too linear
var MIN_CHANGE_IN_SCREE_PLOT_SLOPE = exports.MIN_CHANGE_IN_SCREE_PLOT_SLOPE = 20 * Math.PI / 180;

// This is used in distance calculations
// export const MIN_OVERLAP_DISTANCE = 1;
var COLUMN_OVERLAP_THRESHOLD = exports.COLUMN_OVERLAP_THRESHOLD = 0.5; // relative to the width of the smaller element being compared

// This makes it easier to read from the top right of an element within a column
var ELEMENT_TOP_RIGHT_READING_MODIFIER = exports.ELEMENT_TOP_RIGHT_READING_MODIFIER = 0.6;


//////////////////
// WEBPACK FOOTER
// ./src/common/documentOrder/documentOrderAlgorithmConstants.js
// module id = 320
// module chunks = 0